import React, { useEffect, useState } from "react";
import images from "../../../assets/images/constantImages";
import icons from "../../../assets/images/constantIcons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { allOrders, getOrdersDetails, updateRequestStatus } from "../../CanteenUsers/OrderSlice";
import { handleError } from "../../Common/ApiCommon/ApiService";

const AllOrdersDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const orderType = location.state?.type || 'all'
  const { orders = [], loading = false } = useSelector((state) => state.orders || {});
  const { orderData } = useSelector((state) => state.orders || {});
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [confirmation, setConfirmation] = useState({ open: false, action: null });


  const confirmAction = (status) => {
    setConfirmation({ open: true, action: status });
  };
  // Fetch all orders on mount
const canteenType = useSelector((state) => state.canteenType.type);

useEffect(() => {
  dispatch(allOrders(canteenType));
}, [canteenType, dispatch]);

  const filteredOrders = orders.filter(order => {
    if (orderType === 'pending') return order.status === 'pending';
    if (orderType === 'closed') return order.status !== 'pending';
    return true;
  });


  useEffect(() => {
    if (filteredOrders.length > 0 && !selectedOrderId) {
      const sortedOrders = [...filteredOrders].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      const latestOrderId = sortedOrders[0]?.id;
      setSelectedOrderId(latestOrderId);
      dispatch(getOrdersDetails(latestOrderId));
    }
  }, [filteredOrders, selectedOrderId, dispatch]);

  // Handle card click to view order
  const handleViewOrder = (id) => {
    setSelectedOrderId(id);
    dispatch(getOrdersDetails(id));
  };

  const proceedAction = async () => {
    try {
      const response = await dispatch(updateRequestStatus({ id: selectedOrderId, status: confirmation.action })).unwrap();
      toast.success(response.message, { duration: 2000 });
      dispatch(allOrders());
      dispatch(getOrdersDetails(selectedOrderId));
      setConfirmation({ open: false, action: null });
      navigate("/mainDashboard/dashboardCt");
    } catch (errors) {
      handleError(errors);
      setConfirmation({ open: false, action: null });
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    return date.toLocaleString("en-US", options);
  };

  if (loading) return <p>Loading ....</p>;

  return (
    <div className="p-4">
      <div className="flex items-center gap-2 text-G500 font-medium mb-4">
        <icons.IoMdArrowRoundBack
          onClick={() => navigate(-1)}
          className="text-G100 text-lg cursor-pointer"
        />
        Order details
      </div>

      <div className="flex flex-col h-auto md:flex-row gap-6">
        {/* Order List */}
        <div className="w-full md:w-[35%] max-h-[76vh] overflow-y-auto vertical">
          {filteredOrders?.length > 0 ? (
            <div className="grid grid-cols-1 gap-4">
              {filteredOrders
                .map((order, index) => (
                  <div
                    key={index}
                    onClick={() => handleViewOrder(order.id)}
                    className={`cursor-pointer bg-white rounded-2xl p-4 flex flex-col justify-between border-2 ${selectedOrderId === order.id ? "border-green" : "border-white"
                      }`}
                  >
                    <div className="flex justify-between text-G500">
                      <p className="text-sm font-semibold">
                        Order ID <span className="text-base">{order.order_uniq_id}</span>
                      </p>
                      <p className="text-xs font-medium">{order?.user?.full_name}</p>
                    </div>
                    <div className="flex justify-between text-G100 text-xs mt-2">
                      <p>{formatDate(order.date)}</p>
                      <p
                        className={`text-white rounded-lg px-2 py-1 ${order.status === "pending"
                          ? "bg-yellow"
                          : order.status === "completed"
                            ? "bg-green700"
                            : "bg-red"
                          }`}
                      >
                        {order.status}
                      </p>
                    </div>
                    <div className="flex flex-col gap-2 text-G500 text-sm my-2">
                      {order.order_items.map((item, idx) => (
                        <div key={idx} className="flex justify-between items-center gap-3">
                          <div className="flex items-center justify-between">
                            <p className="w-56 flex items-center">
                              <img
                                src={item.image}
                                alt={item.item_name}
                                className="w-8 h-8 rounded-full mr-3"
                              />
                              {item.item_name}
                            </p>
                            <h1>X{item.quantity}</h1>
                          </div>
                          <div className="font-medium">₹ {item.total_price}</div>
                        </div>
                      ))}
                    </div>
                    <div className="mt-auto">
                      <hr className="border-b-[1px] border-white mb-2" />
                      <div className="flex justify-between items-center text-G500">
                        <p className="font-semibold text-lg flex">
                          <span className="text-green700 mr-1">₹</span>
                          {order.total_price}
                        </p>
                        <button className="bg-green50 rounded-lg px-4 py-1 text-green text-sm font-medium">
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          ) : (
            <div className="w-full flex justify-center items-center mt-5">
              <img
                src={images.noorderimagedash}
                alt="noorderimage"
                className="object-cover w-40 h-40 bg-cover bg-center"
              />
            </div>
          )}
        </div>

        {/* Order Details */}
        <div className="w-full md:w-[65%] h-auto bg-white rounded-2xl p-4 self-center">
          {orderData && orderData.id === selectedOrderId ? (
            <>
              <div className="flex justify-between text-G500">
                <p className="text-lg font-semibold">
                  Order ID <span>{orderData.order_uniq_id}</span>
                </p>
                <p className="text-sm font-medium">{orderData?.user?.full_name}</p>
              </div>
              <div className="flex justify-between text-G100 text-xs mt-2">
                <p>{formatDate(orderData.date)}</p>
                <p className="bg-green50 text-green rounded-lg px-2 py-1">
                  {orderData.order_type}
                </p>
              </div>
              <hr className="border-b-[1px] border-G30 my-2" />
              <p className="text-sm font-semibold mb-2">Order</p>
              <div className="flex flex-col gap-5 text-G500 text-sm my-2 h-60 overflow-y-auto vertical">
                {orderData?.order_items?.map((item, idx) => (
                  <div key={idx} className="flex justify-between">
                    <div className="flex items-center">
                      <img
                        src={item?.image}
                        alt={item?.item_name}
                        className="w-16 h-16 rounded-full mr-3"
                      />
                      <div className="flex flex-col gap-1">
                        <p className="text-base font-medium">{item?.item_name}</p>
                        <h1>X{item.quantity}</h1>
                      </div>
                    </div>
                    <div className="font-medium">₹ {item?.total_price}</div>
                  </div>
                ))}
              </div>
              <hr className="border-b-[1px] border-G30" />
              <div className="flex justify-between items-center text-G800 my-3">
                <button className="text-xl font-semibold">Total</button>
                <p className="font-semibold text-xl flex">
                  <span className="text-green mr-1">₹</span>
                  {orderData?.total_price}
                </p>
              </div>
              {orderData?.status === "pending" && (
                <div className="flex justify-start gap-8">
                  <button
                    onClick={() => confirmAction("accept")}
                    className="bg-green text-white rounded-lg py-2 px-6 text-base font-medium"
                  >
                    Accept
                  </button>
                  <button
                    onClick={() => confirmAction("reject")}
                    className="bg-red text-white rounded-lg py-2 px-6 text-base font-medium"
                  >
                    Reject
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="text-center text-G500 ">No order selected</div>
          )}
        </div>
      </div>

      {confirmation.open && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">
          <div className="bg-white rounded-xl p-6 w-80 text-center shadow-xl">
            <h2 className="text-lg font-semibold mb-4 text-G800">
              Are you sure you want to {confirmation.action} this order?
            </h2>
            <div className="flex justify-center gap-4 mt-4">
              <button
                onClick={proceedAction}
                className="bg-green text-white rounded-lg py-[6px] px-4 w-20"
              >
                Yes
              </button>
              <button
                onClick={() => setConfirmation({ open: false, action: null })}
                className="border border-green text-green rounded-lg py-[6px] w-20 text-center"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default AllOrdersDetails;

